module.exports = __webpack_public_path__ + "static/img/name_ink.eadfd5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/name_ink.png
// module id = KQIN
// module chunks = 18